/**
 * Usage: number | localNumberThousandFormat:'format'
 * If no format is provided 2 decimals will be used.
 **/

import { Pipe, PipeTransform } from "@angular/core";
import { formatNumber } from "@angular/common";
import { LocaleService } from "../services/locale.service";

@Pipe({
  name: "localNumberThousandFormat",
})
export class LocalNumberThousandFormatPipe implements PipeTransform {
  constructor(private locale: LocaleService) {}

  transform(value: any, format: string) {
    if (value === null) {
      return "";
    } // !value would also react to zeros.
    if (!format) {
      format = ".0-1";
    }
    const convertedNumber = convertNumberInThousand(value);
    const formatedNumber = formatNumber(convertedNumber.value, this.locale.locale, format);

    return convertedNumber.unit ? formatedNumber + convertedNumber.unit : formatedNumber;
  }
}

const convertNumberInThousand = (n) => {
  if (n < 1e3) return { value: n };
  if (n >= 1e3 && n < 1e6) return { value: +(n / 1e3), unit: "k" };
  if (n >= 1e6 && n < 1e9) return { value: +(n / 1e6), unit: "M" };
  if (n >= 1e9 && n < 1e12) return { value: +(n / 1e9), unit: "B" };
  if (n >= 1e12) return { value: +(n / 1e12), unit: "T" };
};
